import {
    EDITMAPPINGLANGUAGELISTADMIN_SUCCESS,
    EDITMAPPINGLANGUAGELISTADMIN_FAILED,
    RESET_EDITMAPPINGLANGUAGELISTADMIN,
    LOADING_EDITMAPPINGLANGUAGELISTADMIN,
    NETWORK_ERROR_EDITMAPPINGLANGUAGELISTADMIN
} from "../types/index";
import { adminServices } from "../../config/axios";

const resetAdminEditLanguage = () => {
    return { type: RESET_EDITMAPPINGLANGUAGELISTADMIN };
};

const adminEditLanguagesList = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_EDITMAPPINGLANGUAGELISTADMIN });
    await adminServices
        .post("editMappingLanguageList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(adminEditLanguagesuccess(res.data));
                    break;
                case "Success":
                    dispatch(adminEditLanguagesuccess(res.data));
                    break;
                default:
                    dispatch(adminEditLanguageFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_EDITMAPPINGLANGUAGELISTADMIN,
                payload: err
            });
        });
};
function adminEditLanguagesuccess(data) {
    return {
        type: EDITMAPPINGLANGUAGELISTADMIN_SUCCESS,
        payload: data
    };
}
function adminEditLanguageFailed(data) {
    return {
        type: EDITMAPPINGLANGUAGELISTADMIN_FAILED,
        payload: data
    };
}

export { resetAdminEditLanguage, adminEditLanguagesList };
